export default {
      id: "detailed-induction-video-usage",
      viewBox: "0 0 68.07 53.3",
      url: __webpack_public_path__ + "sprite.svg#detailed-induction-video",
      toString: function () {
        return this.url;
      }
    }